import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import { COMPANY, PHONES, EMAIL } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="border-t border-[#1f1f22] bg-[#08080a]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img src="/logo_mark.png" alt="Shree Aryavarta Developers" className="h-16 w-16 object-contain" />
              <span className="font-serif text-xl">{COMPANY}</span>
            </div>
            <p className="text-[#8f8f94] text-sm leading-relaxed max-w-md">
              Curating premium plotted developments at Shujalpur, Madhya Pradesh.
              Where heritage land meets modern infrastructure.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a href="https://instagram.com/shreearyavartadevelopers" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="h-9 w-9 inline-flex items-center justify-center border border-[#2a2a2d] hover:border-[#c5a059] rounded-full text-[#cfcfd2] hover:text-[#c5a059] transition" aria-label="Instagram @shreearyavartadevelopers">
                <Instagram size={16} />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="label-overline mb-4">Explore</p>
            <ul className="space-y-2.5 text-sm">
              {["About", "Projects", "Amenities", "Location", "Gallery", "Contact"].map((x) => (
                <li key={x}>
                  <Link
                    to={`/${x.toLowerCase()}`}
                    data-testid={`footer-link-${x.toLowerCase()}`}
                    className="text-[#cfcfd2] hover:text-[#c5a059] transition"
                  >
                    {x}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="label-overline mb-4">Contact</p>
            <ul className="space-y-3 text-sm text-[#cfcfd2]">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[#c5a059] flex-shrink-0" />
                <a
                  href="https://maps.app.goo.gl/p6Ca7LpS7cJfHEqG9"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-address-map"
                  className="hover:text-[#c5a059] transition"
                >
                  Freeganj, Ashta Road, Shujalpur, Shajapur District, Madhya Pradesh 465333
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#c5a059] mt-0.5" />
                <div className="flex flex-col gap-1">
                  {PHONES.map((p, i) => (
                    <a
                      key={p.tel}
                      href={`tel:${p.tel}`}
                      data-testid={`footer-phone-${i}`}
                      className="hover:text-[#c5a059]"
                    >
                      {p.display}
                    </a>
                  ))}
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[#c5a059]" />
                <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="hover:text-[#c5a059]">{EMAIL}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline my-10" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#6f6f74]">
          <p>© {new Date().getFullYear()} {COMPANY}. All rights reserved.</p>
          <p className="tracking-[0.2em] uppercase">Launching Soon · Shujalpur, MP</p>
        </div>
      </div>
    </footer>
  );
}
